module.exports = __webpack_public_path__ + "img/pyb-logo.24a9e284.png";